import 'isotope-layout/dist/isotope.pkgd';
import tippy from 'tippy.js';

/*
	Author: nicdark
	Author URI: http://www.nicdarkthemes.com/
*/


(function($) {
	"use strict";

	var showMore = true;
	var activeFilter = '*';

	function removeHiddenClass() {
        $('.nicdark_masonry_item').each(function(cIndex, cData) {
            $(this).removeClass('hidden');
        });
	}

	function addHiddenClass() {
        $('.nicdark_masonry_item').each(function(cIndex, cData) {
            if (activeFilter !== '*') {
                removeHiddenClass();
                $(activeFilter).each(function(cIndex, cData) {
                	if (!showMore) {
                        if (cIndex > 5) {
                            $(this).addClass('hidden');
                        }
					}
                });
            }
            else {
                if (!showMore) {
                    removeHiddenClass();
                    $('.nicdark_masonry_item').each(function(cIndex, cData) {
                        if (cIndex > 5) {
                            $(this).addClass('hidden');
                        }
                    });
                }
                else {
                	removeHiddenClass();
				}
            }
        });
	}

	function initIsotope() {
        $('.nicdark_masonry_btns div a').click( function() {
            var filterValue = $( this ).attr('data-filter');
			activeFilter = filterValue;
            if (filterValue !== '*') {
            	if (showMore) {
                    removeHiddenClass();
                    $(filterValue).each(function(cIndex, cData) {
                        if (cIndex > 5) {
                            $(this).addClass('hidden');
                        }
                    });
				}
			}
			else {
				removeHiddenClass();
                addHiddenClass();
			}

            $container.isotope({ filter: filterValue });
        });

        var $container = $('.nicdark_masonry_container').isotope({
            itemSelector: '.nicdark_masonry_item'
        });
	}
	//isotope
	$( window ).ready(function() {
		initIsotope()

		$( '.nicdark_simulate_click' ).trigger( "click" );
		$( '.filter-button' ).click(function(event) {
			setActiveFilterButton(event);
        });

		$('.show-more-button').click(function () {
			if (showMore) {
                removeHiddenClass();

                initIsotope();

                $('.show-more-button').html('<i class="icon-th-list"></i>&nbsp;&nbsp;&nbsp;Bekijk minder');
                showMore = !showMore;
			}
			else {
                addHiddenClass();

                initIsotope();

                $('.show-more-button').html('<i class="icon-th-list"></i>&nbsp;&nbsp;&nbsp;Bekijk meer');
                showMore = !showMore;
			}
		});
	});

	function setActiveFilterButton(event) {
		var clickedButton = event.target;

		$('.filter-button').each(function(cIndex, cData) {
			$(this).removeClass('bg_pink white');

			if (this === clickedButton) {
				$(this).addClass('bg_pink white');
			}
		});
	}
	///////////




	//inview
	var windowWidth = $(window).width();

	if (windowWidth < 400){

		$('.fade-left, .fade-up, .fade-down, .fade-right, .bounce-in, .rotate-In-Down-Left, .rotate-In-Down-Right').css('opacity','1');

	}else{

		$('.fade-up').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated fadeInUp'); } });
		$('.fade-down').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated fadeInDown'); } });
		$('.fade-left').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated fadeInLeft'); } });
		$('.fade-right').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated fadeInRight'); } });
		$('.bounce-in').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated bounceIn'); } });
		$('.rotate-In-Down-Left').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated rotateInDownLeft'); } });
		$('.rotate-In-Down-Right').bind('inview', function(event, visible) { if (visible == true) { $(this).addClass('animated rotateInDownRight'); } });

	}
	///////////


	//menu
	$('.nicdark_menu').superfish({});
	//megamenu
	$('.nicdark_megamenu ul a').removeClass('sf-with-ul');
	$($('.nicdark_megamenu ul li').find('ul').get().reverse()).each(function(){
	  $(this).replaceWith($('<ol>'+$(this).html()+'</ol>'))
	})
	//responsive
	/* $('.nicdark_menu').tinyNav({
		active: 'selected',
		header: 'MENU'
	}); */
	///////////


	//fixed menu
	jQuery(window).scroll(function(){
		add_class_scroll();
	});
	add_class_scroll();
	function add_class_scroll() {
		if(jQuery(window).scrollTop() > 100) {
			jQuery('.nicdark_navigation').addClass('slowup');
			jQuery('.nicdark_navigation').removeClass('slowdown');
		} else {
			jQuery('.nicdark_navigation').addClass('slowdown');
			jQuery('.nicdark_navigation').removeClass('slowup');
		}
	}
	///////////

	//tooltip
	$('.nicdark_tooltip').each((index, element) => {
		tippy(element, {
			content: $(element).data('content'),
		});
	})

	//tab
	$('.nicdark_tab').tabs({show: 'fade', hide: 'fade'});
	//toogle
	$( '.nicdark_toogle' ).accordion({
		heightStyle: "content",
		collapsible: true,
		active: false
	});
	//accordion
	$( '.nicdark_accordion' ).accordion({
		heightStyle: "content"
	});
	//slider-range
	$( ".nicdark_slider_range" ).slider({
		range: true,
		min: 0,
		max: 1000,
		values: [ 200, 700 ],
		slide: function( event, ui ) {
			$( ".nicdark_slider_amount" ).val( "$ " + ui.values[ 0 ] + " - $ " + ui.values[ 1 ] );
		}
	});
	$( ".nicdark_slider_amount" ).val( "$ " + $( ".nicdark_slider_range" ).slider( "values", 0 ) + " - $ " + $( ".nicdark_slider_range" ).slider( "values", 1 ) );
	//slider-range-select
	var nicdark_slider_range_select_is_present = $( '.nicdark_slider_range_select' ).length;
	if ( nicdark_slider_range_select_is_present != 0 ){
		var select = $( ".nicdark_slider_range_select" );
		var slider = $( "<div class='nicdark_bg_greydark2' style='width:40%; float:left; margin-top:18px;' id='slider'></div>" ).insertAfter( select ).slider({
			min: 1,
			max: 15,
			range: "min",
			value: select[ 0 ].selectedIndex + 1,

			change: function( event, ui ) {
				nicdark_cost_calculator();
			},

			slide: function( event, ui ) {
				select[ 0 ].selectedIndex = ui.value - 1;
			}
		});
		$( ".nicdark_slider_range_select" ).change(function() {
			slider.slider( "value", this.selectedIndex + 1 );
		});
	}
	//alerts
	$('.nicdark_alerts').click(function(event){
		$(this).css({
			'display': 'none',
		});
	});
	//progressbar
	$('.animate_progressbar').bind('inview', function(event, visible) { if (visible == true) { $(this).removeClass('animate_progressbar'); } });
	///////////



	//internal-link
	$('.nicdark_internal_link').click(function(event){

		event.preventDefault();
		var full_url = this.href;
		var parts = full_url.split("#");
		var trgt = parts[1];
		var target_offset = $("#"+trgt).offset();
		var target_top = target_offset.top;

		$('html,body').animate({scrollTop:target_top -50}, 900);

	});
	///////////



	//counter
	$('.nicdark_counter').data('countToOptions', {
		formatter: function (value, options) {
			return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
		}
	});
	// start all the timers
	$('.nicdark_counter').bind('inview', function(event, visible) {
		if (visible == true) {
			$('.nicdark_counter').each(count);
		}
	});
	function count(options) {
		var $this = $(this);
		options = $.extend({}, options || {}, $this.data('countToOptions') || {});
		$this.countTo(options);
	}
	///////////



	//left sidebar OPEN
	$('.nicdark_left_sidebar_btn_open').click(function(event){
		$('.nicdark_left_sidebar').css({
			'left': '0px',
		});
		$('.nicdark_site, .nicdark_navigation').css({
			'margin-left': '300px',
		});
		$('.nicdark_overlay').addClass('nicdark_overlay_on');
	});
	//left sidebar CLOSE
	$('.nicdark_left_sidebar_btn_close, .nicdark_overlay').click(function(event){
		$('.nicdark_left_sidebar').css({
			'left': '-300px'
		});
		$('.nicdark_site, .nicdark_navigation').css({
			'margin-left': '0px'
		});
		$('.nicdark_overlay').removeClass('nicdark_overlay_on');
	});
	//right sidebar OPEN
	$('.nicdark_right_sidebar_btn_open').click(function(event){
		$('.nicdark_right_sidebar').css({
			'right': '0px',
		});
		$('.nicdark_site, .nicdark_navigation').css({
			'margin-left': '-300px',
		});
		$('.nicdark_overlay').addClass('nicdark_overlay_on');
	});
	//right sidebar CLOSE
	$('.nicdark_right_sidebar_btn_close, .nicdark_overlay').click(function(event){
		$('.nicdark_right_sidebar').css({
			'right': '-300px'
		});
		$('.nicdark_site, .nicdark_navigation').css({
			'margin-left': '0px'
		});
		$('.nicdark_overlay').removeClass('nicdark_overlay_on');
	});
	///////////


})(jQuery);
